import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { AppUI } from '@seedlang/state';
import { TeamMemberStore } from '@seedlang/stores';
import styled from '@emotion/styled';
import Spinner from 'components/spinner';
import HeaderBar from 'components/header_bar';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h2 {
    margin: 0;
    text-align: center;
    line-height: 30px;
  }
`;

const HeaderWrapper = styled.div`
  width: 100%;
`;

const Content = styled.div`
  width: 100%;
  margin-top: 10px;
`;

const TeamMembers = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(${props => props.minColumnWidth}, 1fr));
  gap: 20px;
`;

const TeamMember = styled.div`
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  padding: 18px;
  align-items: center;
  border-radius: 5px;
  min-height: 100%;
`;

const Image = styled.div`
  width: 150px;
  height: 150px;
  background-size: cover;
  border-radius: 50%;
  margin-top: 10px;
  .user-icon {
    background: #333;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    display: flex;
    svg g {
      fill: #FFF;
    }
  }
  svg {
    fill: #FFF;
    width: 80px;
    height: 80px;
  }
`;

const InfoColumn = styled.div`
  flex: 1;
  padding: 10px;
`;

const Name = styled.div`
  font-weight: bold;
  text-align: center;
`;

const Title = styled.div`
  text-align: center;
  font-style: italic;
  height: 30px;
`;

const Description = styled.div`
  font-size: 16px;
  line-height: 22px;
  margin-top: 10px;
  a {
    text-decoration: underline;
  }
  p {
    margin: 0;
    padding: 0;
  }
`;

@observer
class Team extends React.Component {

  constructor(props) {
    super(props);
    TeamMemberStore.getIndex({ queryStrings: { active: 'true' } });
  }

  render() {
    return (
      <Wrapper>
        <HeaderWrapper>
          <HeaderBar
            title='Our Team'
            titleRoute='team'
            margin='0'
          />
        </HeaderWrapper>
        <Content>
          <TeamMembers
            minColumnWidth={AppUI.layout.isMobile ? '260px' : '320px'}
          >
            {
              !TeamMemberStore.hasIndexData &&
              <Spinner />
            }
            {
              TeamMemberStore.indexData.map(item => {
                return (
                  <TeamMember
                    key={item.id}
                  >
                    <Image
                      style={{
                        backgroundImage: `url(${item.imageUrl})`,
                      }}
                    />
                    <InfoColumn>
                      <Name>
                        {item.name}
                      </Name>
                      <Title>
                        {item.title}
                      </Title>
                      <Description
                        dangerouslySetInnerHTML={{ __html: item.bio }}
                      />
                    </InfoColumn>
                  </TeamMember>
                );
              })
            }
          </TeamMembers>
        </Content>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Team);
